import confetti from 'canvas-confetti';

const COUNT = 200;
const DEFAULT_CONFIG: confetti.Options = {
  origin: { y: 0.85 }
};

const fire = (particleRatio: number, opts: confetti.Options) => {
  confetti({
    ...DEFAULT_CONFIG,
    ...opts,
    particleCount: Math.floor(COUNT * particleRatio)
  });
};

export const fireConfetti = () => {
  fire(0.25, {
    spread: 26,
    startVelocity: 55
  });
  fire(0.2, {
    spread: 60
  });
  fire(0.35, {
    spread: 100,
    decay: 0.91,
    scalar: 0.8
  });
  fire(0.1, {
    spread: 120,
    startVelocity: 25,
    decay: 0.92,
    scalar: 1.2
  });
  fire(0.1, {
    spread: 120,
    startVelocity: 45
  });
};
